var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentCallVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4775 0C13.6216 3.93774e-05 14.666 0.800888 14.666 3.20898V9.625C14.666 12.0331 13.6117 12.8339 10.4775 12.834H4.18848C1.04441 12.8339 0 11.2329 0 9.625V3.20898C0 0.800899 1.04441 4.63519e-05 4.18848 0H10.4775ZM10.541 2.75C9.78189 2.75019 9.16619 3.36587 9.16602 4.125C9.16602 4.88428 9.78178 5.49981 10.541 5.5C11.3004 5.5 11.916 4.88439 11.916 4.125C11.9158 3.36576 11.3003 2.75 10.541 2.75Z",
    fill: "#0AA02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3189 10.6189L14.8965 9.01291V3.816L17.3189 2.20999C18.5039 1.42757 19.4798 1.90526 19.4798 3.28067V9.55649C19.4798 10.9319 18.5039 11.4096 17.3189 10.6189Z",
    fill: "#0AA02E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentCallVideo);
export default __webpack_public_path__ + "static/media/recent-call-video.830c1c895a0ebc4639464c0ed96a3d23.svg";
export { ForwardRef as ReactComponent };